import { render } from "./LungIcon.vue?vue&type=template&id=24b6a51e"
import script from "./LungIcon.vue?vue&type=script&lang=ts"
export * from "./LungIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script